import gpsCareLogo from "./Images/Logos/gps_care_logo.png";
import tlsCareLogo from "./Images/Logos/tlscare_logo.svg";
import meta from "./brandMeta.json";

const BRANDS = {
  gpscare: { ...meta.gpscare, logo: gpsCareLogo },
  tlscare: { ...meta.tlscare, logo: tlsCareLogo },
};

// Defaults to gpscare so a build with no REACT_APP_BRAND behaves exactly as before.
const requested = (process.env.REACT_APP_BRAND || "gpscare").toLowerCase();
if (!BRANDS[requested]) {
  console.warn(`Unknown REACT_APP_BRAND "${requested}", falling back to gpscare`);
}

export const brandKey = BRANDS[requested] ? requested : "gpscare";
export const brand = BRANDS[brandKey];
